import { Link } from "react-router-dom";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

export const SurveysRightBar = [
  RightBarMethod(
    " HELP TOPICS",
    "t1",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Surveys", "1", "", "", "/")]
  ),
];


export const propertyList = [
    {
      value: "test property",
      label: "test property",
    },
    {
      value: "test property2",
      label: "test property2",
    },
    {
      value: "test property3",
      label: "test property3",
    },
  ];
  export const typeList = [
    {
      value: "Maintenance",
      label: "Maintenance",
    },
    {
      value: "Move In",
      label: "Move In",
    },
    {
      value: "Move Out",
      label: "Move Out",
    },
    {
      value: "Showing",
      label: "Showing",
    },
  ];


//   Responses table 
export const tableColumns = [
  {
    title: "Survey",
    dataIndex: "survey",
    key: 'survey',
        render: (text, record) => <span className="onclick-text" >{text}</span>,

  },
  {
    title: "Satisfaction",
    dataIndex: "satisfaction",
  },
  {
    title: "Person Evaluated",
    dataIndex: "personEvaluated",
  },
  {
    title: "Submitted By",
    dataIndex: "submittedBy",
  },
  {
    title: "Property",
    dataIndex: "property",
  },
  {
    title: "Submitted At",
    dataIndex: "submittedAt",
  },
];

export const tableData = [];
for (let i = 0; i < 100; i++) {
    tableData.push({
      key: i,
      survey: `Maintenance`,
      satisfaction: Math.floor(Math.random() * 5),
      personEvaluated: `Bolding Electric ${i}`,
      submittedBy: `Alexander Truoccolo ${i}`,
      property: `${Math.floor(Math.random() * 1000)} NE 3rd Pl`,
      submittedAt: `9/${Math.floor(Math.random() * 30)}/2022 at ${Math.floor(Math.random() * 24)}:07 `,
    });
  }